import { useSettings } from '@wu/widget-core';
import type { StripeIntegrationSettings } from '../../common/types';

export function useIsStripeConnected() {
  const {
    integrationStripe: {
      id: stripeIntegrationId,
      publishableKey: stripePublicKey
    }
  } = useSettings<StripeIntegrationSettings>();

  return !!(stripeIntegrationId && stripePublicKey);
}
